import { createSlice } from '@reduxjs/toolkit'

const initialState = { program:[]}

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    addProgram(state, action) {
       return action.payload
    }
  },
})

export const { addProgram } = programSlice.actions
export default programSlice.reducer